import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {
  Grid,
  Button,
  Item,
  Card,
  Image,
  Container,
  Segment,
  Modal,
} from 'semantic-ui-react';
import Icon from '@plone/volto/components/theme/Icon/Icon';

import { MixedTitle } from '..';
import squaredArrowSVG from '../../static/squared-arrow.svg';
import arrowSVG from '../../icons/arrow.svg';

const HomepageNews = ({ news, jobs }) => {
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);

  return (
    <Segment
      basic
      as="section"
      className="aktuelles"
      style={{ marginBottom: '100px' }}
    >
      <Container>
        <Grid stackable>
          <Grid.Column tablet={12} computer={6} className="main-column">
            <div style={{ paddingBottom: '40px' }}>
              <div
                style={{ marginBottom: '65px' }}
                className="underlined-title"
              >
                <span>Aktuelles</span>
              </div>
              <Card.Group stackable centered itemsPerRow={2}>
                {news.map((item) => (
                  <Card key={item['@id']} as={Link} to={item.url}>
                    {item.image && <Image src={item.image.download} />}
                    <Card.Content>
                      <div className="underlined-title">
                        <span>
                          {moment(item.effective || item.created).format(
                            'DD.M.YYYY',
                          )}
                        </span>
                      </div>
                      <Card.Header>{item.title}</Card.Header>
                    </Card.Content>
                    <Card.Content extra>
                      <div style={{ textAlign: 'right' }}>
                        <Button className="small brandButtonSecondary ">
                          <MixedTitle>Mehr lesen</MixedTitle>
                          <Icon name={arrowSVG} size="17px" className="right" />
                        </Button>
                      </div>
                    </Card.Content>
                  </Card>
                ))}
              </Card.Group>
            </div>
          </Grid.Column>
          <Grid.Column tablet={12} computer={1} />
          <Grid.Column tablet={12} computer={5} className="secondary-column">
            <div style={{ marginBottom: '65px' }} className="underlined-title">
              <span>Newsletter</span>
            </div>
            <div style={{ marginBottom: '55px' }}>
              <h3>Im Fokus</h3>
              <p>
                Erhalten Sie regelmäßig Neuigkeiten zu unseren Produkten,
                Rezepten und Anwendungsrezepturen.
              </p>
              <Button
                className="large brandButtonSecondary"
                onClick={() => setShowNewsletterModal(true)}
              >
                <MixedTitle>Hier anmelden</MixedTitle>
                <Icon name={arrowSVG} size="23px" className="right" />
              </Button>
              <Modal
                open={showNewsletterModal}
                onClose={() => setShowNewsletterModal(false)}
                size="small"
              >
                <Modal.Header>Hinweis</Modal.Header>
                <Modal.Content>
                  <p>
                    Für die Anmeldung zu unserem Newsletter werden Sie auf ein
                    Formular unseres Dienstleisters Brevo weitergeleitet. Dort
                    werden Ihre Daten ausschließlich zur Zusendung des
                    Newsletters verarbeitet. Alle Informationen zum Umgang mit
                    Ihren personenbezogenen Daten finden Sie in unserer
                    Datenschutzerklärung.
                  </p>
                </Modal.Content>
                <Modal.Actions>
                  <Button
                    className="medium brandButtonSecondary"
                    onClick={() => setShowNewsletterModal(false)}
                  >
                    Zurück
                  </Button>
                  <a
                    className="ui medium button brandButtonPrimary"
                    href="https://ba001d52.sibforms.com/serve/MUIFAI-W775ju1-6JhVaDasD41qWsoMX24QXeBplNKsjuFbtuCqRwyipSNWWCNV9SJLQpSXUgb00RnKv985dM3iuX6ZujhlhJuusgD9NO3GiL5lCbQr4KtgX3-4VG1O-wWUm2aX83fmwi2c6GXoVNfG-af1HtlA_i73ml_hGNK_hX7fKhfdP_2O9ZoLyIPlXTrDXPiBZlpWgMMEs"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => setShowNewsletterModal(false)}
                  >
                    Anmelden
                    <Icon name={arrowSVG} size="23px" className="right" />
                  </a>
                </Modal.Actions>
              </Modal>
            </div>
            <div style={{ marginBottom: '65px' }} className="underlined-title">
              <span>Aktuelle Stellenangebote</span>
            </div>

            <Item.Group unstackable style={{ marginBottom: '34px' }}>
              {jobs.map((item) => (
                <Item key={item.linkJobAd}>
                  <Item.Image src={squaredArrowSVG} />
                  <Item.Content>
                    <Item.Header>
                      <a href={item.linkJobAd} target="_blank" rel="noreferrer">
                        {item.name}
                      </a>
                    </Item.Header>
                  </Item.Content>
                </Item>
              ))}
            </Item.Group>

            <Button
              className="medium brandButtonSecondary"
              as={Link}
              to="/wir-ueber-uns/karriere/stellenangebote"
            >
              <MixedTitle>Alle Stellenangebote</MixedTitle>
              <Icon name={arrowSVG} size="23px" className="right" />
            </Button>
          </Grid.Column>
        </Grid>
      </Container>
    </Segment>
  );
};

HomepageNews.propTypes = {
  news: PropTypes.arrayOf(
    PropTypes.shape({
      '@id': PropTypes.string,
    }),
  ),
  jobs: PropTypes.arrayOf(
    PropTypes.shape({
      '@id': PropTypes.string,
    }),
  ),
};

HomepageNews.defaultProps = {
  news: [],
  jobs: [],
};

export default HomepageNews;
